"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-ChevronRightMedium" },
      _react2.default.createElement("path", { d: "M5.99 5a1 1 0 0 0-.29-.707L1.717.3A1 1 0 1 0 .3 1.717L3.586 5 .3 8.283A1 1 0 1 0 1.717 9.7L5.7 5.707A1 1 0 0 0 5.99 5z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M7.5 6a1 1 0 0 0-.293-.707L2.217.3A1 1 0 1 0 .8 1.717L5.086 6 .8 10.283A1 1 0 1 0 2.217 11.7l4.99-4.99A1 1 0 0 0 7.5 6z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'ChevronRightMedium';
exports.default = WrappedIcon;

